import { ChatMessage } from "../types/chat";

/**
 * Returns the initial welcome message that appears when the chat page first loads
 */
export function getWelcomeMessage(): ChatMessage {
  return {
    id: crypto.randomUUID(),
    messageId: "a3590262-2838-4625-b422-92118efa466a",
    text: "Hi, I'm a virtual assistant here to help you with using the Aveta System. What can I assist you with today?\n",
    messageType: "bot",
    dateTime: new Date(),
    nodeUuid: "a3590262-2838-4625-b422-92118efa466a",
    options: [
      [
        "[Next] Performing a Procedure[c]How do I use the Aveta System[/c][c]How do I perform a procedure[/c]",
        "7b3c8d7c-e6bc-4daf-85a0-a66264bc4c8c",
      ],
      [
        "[Next] Setting up the System[c]How do I set up the Aveta System[/c][c]How do I set up the system[/c][c]How to setup[/c]",
        "a53f936b-2468-4fdb-bfb3-830bbbc364ab",
      ],
      [
        "[Next] Accessing Images[c]How do I print[/c][c]How do I copy images (onto a USB stick)[/c]",
        "d7ad4ee0-8b4e-4a15-83f4-04a7af9c7463",
      ],
      [
        "[Next] Help Troubleshooting[c]Do not select this unless the user's message says I need help troubleshooting or I need help without describing the problem.[/c]",
        "9cea4eeb-56f7-4ef1-b3a6-848731970cb5",
      ],
    ],
    endpoint_result: "RESOLVED_VIRTUAL",
    comingFrom: "RESOLVED_VIRTUAL",
    isFlagged: false,
  };
}
